export default "__VITE_ASSET__Bkimb5$7__"